import { observable, computed } from 'mobx';
import intersection from 'lodash/intersection';
import difference from 'lodash/difference';
import { fromPromise } from 'mobx-utils';

class CardCompletionInfoStore {
  cardId = '';
  @observable.ref allCompletedUserIds = [];

  constructor(store, cardId) {
    this.store = store;
    this.cardId = cardId;
  }

  @computed
  get completedUserIds() {
    const connectedLearnerIds = this.store.participants.learnerMedias.map(m => m.userId);
    return intersection(this.allCompletedUserIds, connectedLearnerIds);
  }

  @computed
  get incompleteUserIds() {
    const connectedLearnerIds = this.store.participants.learnerMedias.map(m => m.userId);
    return difference(connectedLearnerIds, this.completedUserIds);
  }

  @computed
  get completedUsers() {
    const learnerMedias = this.store.participants.learnerMedias;
    const completedUserIds = this.completedUserIds;
    const completedUserMedias = learnerMedias.filter(m => completedUserIds.includes(m.userId));

    if (completedUserMedias.length < 1) {
      return fromPromise.resolve([]);
    }

    const promise = Promise.all(completedUserMedias.map(m => m.user));
    return fromPromise(promise);
  }

  @computed
  get incompleteUsers() {
    const learnerMedias = this.store.participants.learnerMedias;
    const incompleteUserIds = this.incompleteUserIds;
    const incompleteUserMedias = learnerMedias.filter(m => incompleteUserIds.includes(m.userId));

    if (incompleteUserMedias.length < 1) {
      return fromPromise.resolve([]);
    }

    const promise = Promise.all(incompleteUserMedias.map(m => m.user));
    return fromPromise(promise);
  }
}

export default CardCompletionInfoStore;
